var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCpp48Filled = function SvgIconCpp48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.19 15.08-11.8-6.43c-.87-.47-1.91-.47-2.78 0l-11.8 6.43a2.9 2.9 0 0 0-1.51 2.55v12.74c0 1.06.58 2.04 1.51 2.55l11.8 6.43c.43.24.91.35 1.39.35.48 0 .95-.12 1.39-.35l11.8-6.43a2.9 2.9 0 0 0 1.51-2.55V17.63c0-1.06-.58-2.04-1.51-2.55Zm-9.34 10.17v2h-2.5v-2h-2v-2.5h2v-2h2.5v2h2v-2h2.5v2h2v2.5h-2v2h-2.5v-2h-2Zm-10.03.53a2.785 2.785 0 0 0 3.85 0l2.36 2.44a6.178 6.178 0 0 1-4.29 1.72c-1.55 0-3.11-.57-4.29-1.72a5.857 5.857 0 0 1-1.81-4.23c0-1.6.64-3.1 1.81-4.23 2.36-2.29 6.21-2.29 8.58 0l-2.36 2.44a2.785 2.785 0 0 0-3.85 0c-.5.48-.77 1.11-.77 1.78 0 .67.27 1.3.77 1.78v.02Z",
    fill: "current"
  })));
};
export default SvgIconCpp48Filled;